export default __webpack_public_path__ + "static/media/Whoweare-img-4.c07dbe19.png";